// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .paddingTitle {
    padding-top: 5%;
    padding-bottom: 2%;
  }

  .versionStyle {
    padding-top: 15%;
    display: flex;
    flex-direction: row;
  }

  .marginRight10 {
    margin-right: 10%;
  }

  .backgroundStyle {
    background: #FAFAFA 0% 0% no-repeat padding-box;
    margin-left: 3%;
    padding-top: 1.5%;
    padding-bottom: 1%;
    margin-top: 2%;
    margin-right: 2%;
  }

  .readMoreStyle {
    border: none;
    color: blue;
    text-decoration: underline;
    margin: 0px;
    padding: 0px;
    margin-left: 2%;
  }

  .publicationsStyle {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 2px;
    margin-right: 3%;
    padding-left: 2%;
    padding-right: 2%;
    padding-top: 2%;
    padding-bottom: 2%;
    margin-bottom: 3%;
    display: flex;
    flex-direction: row;
  }

  .videoBgStyle {
    background: #F5F5F5 0% 0% no-repeat padding-box;
    height: 100%;
    padding-right: 4%;
    padding-left: 4%;
    padding-top: 2%;
}

.videoLinkStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  margin-top: 8%;
  padding-top: 1%;
}

.vidLinkStyle {
  text-align: left;
  font: normal normal 600 16px/24px;
  letter-spacing: 0px;
  color: #262626;
  padding-left: 5%;
}

.videoPreviewStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  margin-top: 8%;
  padding-top: 1%;
}

.doiStyle {
  text-align: left;
  font: normal 600 16px/24px;
  letter-spacing: 0px;
  color: #262626;
  padding-left: 5%;
}

.doiButtonStyle {
  letter-spacing: 0px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 2px;
}

.subGrpStyles {
  margin-bottom: 5%;
  color: #595959;
  font: normal normal normal 14px/22px;
  background: #F5F5F5 0% 0% no-repeat padding-box;
  border-radius: 2px;
}

.userOutlinedStyle {
  padding-top: 0.4%;
  padding-left: 1%;
  padding-right: 0.5%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/DetailedStudyStyle.css"],"names":[],"mappings":"EAAE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,+CAA+C;IAC/C,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,+CAA+C;IAC/C,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,+CAA+C;IAC/C,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE,+CAA+C;EAC/C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oCAAoC;EACpC,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["  .paddingTitle {\n    padding-top: 5%;\n    padding-bottom: 2%;\n  }\n\n  .versionStyle {\n    padding-top: 15%;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .marginRight10 {\n    margin-right: 10%;\n  }\n\n  .backgroundStyle {\n    background: #FAFAFA 0% 0% no-repeat padding-box;\n    margin-left: 3%;\n    padding-top: 1.5%;\n    padding-bottom: 1%;\n    margin-top: 2%;\n    margin-right: 2%;\n  }\n\n  .readMoreStyle {\n    border: none;\n    color: blue;\n    text-decoration: underline;\n    margin: 0px;\n    padding: 0px;\n    margin-left: 2%;\n  }\n\n  .publicationsStyle {\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border-radius: 2px;\n    margin-right: 3%;\n    padding-left: 2%;\n    padding-right: 2%;\n    padding-top: 2%;\n    padding-bottom: 2%;\n    margin-bottom: 3%;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .videoBgStyle {\n    background: #F5F5F5 0% 0% no-repeat padding-box;\n    height: 100%;\n    padding-right: 4%;\n    padding-left: 4%;\n    padding-top: 2%;\n}\n\n.videoLinkStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  margin-top: 8%;\n  padding-top: 1%;\n}\n\n.vidLinkStyle {\n  text-align: left;\n  font: normal normal 600 16px/24px;\n  letter-spacing: 0px;\n  color: #262626;\n  padding-left: 5%;\n}\n\n.videoPreviewStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  margin-top: 8%;\n  padding-top: 1%;\n}\n\n.doiStyle {\n  text-align: left;\n  font: normal 600 16px/24px;\n  letter-spacing: 0px;\n  color: #262626;\n  padding-left: 5%;\n}\n\n.doiButtonStyle {\n  letter-spacing: 0px;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border-radius: 2px;\n}\n\n.subGrpStyles {\n  margin-bottom: 5%;\n  color: #595959;\n  font: normal normal normal 14px/22px;\n  background: #F5F5F5 0% 0% no-repeat padding-box;\n  border-radius: 2px;\n}\n\n.userOutlinedStyle {\n  padding-top: 0.4%;\n  padding-left: 1%;\n  padding-right: 0.5%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
